import React, { useState } from 'react';
import { getIcons } from '../../Constant/Constant';


const icons= getIcons();

const MediumData = [
  { id: 1, label: 'Bulk Email',  icon: icons.mailIcon },
  { id: 2, label: 'Bulk Whats App',  icon: icons.whatsAppIcon },
  { id: 3, label: 'Bulk SMS',  icon: icons.smsIcon },

];
export default function MediumSelection({method}) {
  const [selectedMedium, setSelectedMedium] = useState(MediumData[0].id);


  const handleSelectedMedium = (medium)=>{
setSelectedMedium(medium)
method(medium)
console.log(medium)
  }
  return (
    <div className="p-4 max-w-lg bg-white rounded-lg shadow-md">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">Choose Medium</h2>
      </div>
      <ul className="space-y-3">
        {MediumData.map((medium) => (
          <li
            key={medium.id}
            className={`flex items-center justify-between p-3 rounded-lg cursor-pointer
              ${selectedMedium === medium.id ? 'bg-green-100 border border-green-500' : 'bg-white border border-gray-300'}
            `}
            onClick={() => handleSelectedMedium(medium.id)}
          >
            <div className="flex items-center space-x-3">
              <img className='w-10' src={medium.icon} alt="" />
              <span className="font-medium">{medium.label}</span>

            </div>
            <div className="flex items-center space-x-2">
              <form>
              <input
                type="radio"
                name="lead"
                checked={selectedMedium === medium.id}
                onChange={() => handleSelectedMedium(medium.id)}
                className="form-radio text-green-500 h-4 w-4"
              />
              </form>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
